import {useEffect, useState} from 'react';

import useDebouncedState from './useDebouncedState';

const useDebouncedOnChange = (onChange, delay = 1000) => {
    const [value, setValue] = useState();
    const [event, setEvent] = useState();
    const [args, setArgs] = useState([]);
    const [debouncedValue, setDebouncedValue] = useState(value);
    useDebouncedState(value, setDebouncedValue, {delay});
    useEffect(() => {
      if (debouncedValue !== undefined) {
        console.log('NOW RUNNING onChange with', debouncedValue);
        onChange(event, debouncedValue, ...args);
      }
    }, [debouncedValue]);
    const debouncedOnChange = (_e, _val, ..._args) => {
      setEvent(_e);
      setValue(_val || _e?.target?.value);
      setArgs(_args);
    };
    return debouncedOnChange;
};

export default useDebouncedOnChange;